import storePersist from "@/redux/storePersist";
import { request } from "@/request";
import { apiConstants } from "@/utils/apiConstant";
import {
  getCookie,
  setCookie,
  deleteCookie,
  getSession,
  setSession,
  deleteSession,
} from "../auth/cookie";
import { ACCESS_TOKEN_NAME } from "@/config/serverApiConfig";
import * as actionTypes from "@/redux/page/types";

export const localStorage = {
  get: () => getCookie(ACCESS_TOKEN_NAME),
  set: (token) => setCookie(ACCESS_TOKEN_NAME, token),
  remove: () => deleteCookie(ACCESS_TOKEN_NAME),
};

export const sessionStorage = {
  get: () => getSession(ACCESS_TOKEN_NAME),
  set: (token) => setSession(ACCESS_TOKEN_NAME, token),
  remove: () => deleteSession(ACCESS_TOKEN_NAME),
};

export const userRegister = async (
  values,
  image,
  navigate,
  dispatch,
  isCreateShopUser,
  modalBtnRef,
  onFinish,
  newCreatedPoc = {}
) => {
  try {
    dispatch({
      type: actionTypes.REQUEST_LOADING,
    });
    const formData = { ...values, file: image?.file };

    const data = new FormData();

    data.append("name", formData?.name);
    data.append("email", formData?.email);
    data.append("phone", formData?.phone);
    data.append("role", formData?.role);
    data.append("photos", formData?.file);
    data.append("photoKeys", "profileImage");

    const entityURL = apiConstants.REGISTER_USER;
    const response = await request.post(entityURL, data);
    if (response?.success) {
      dispatch({
        type: actionTypes.REQUEST_SUCCESS,
      });
      newCreatedPoc.current = response?.result;
      if (isCreateShopUser) {
        modalBtnRef?.current?.setIsModalOpen(false);
      } else {
        navigate(-1);
      }
    }
    dispatch({
      type: actionTypes.LOADING_FALSE,
    });
    onFinish();
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error registering user:", error);
    dispatch({
      type: actionTypes.LOADING_FALSE,
    });
  }
};

export const login = async (loginAdminData) => {
  try {
    const entityURL = apiConstants.LOGIN_API_ENDPOINT;
    const response = await request.post(entityURL, loginAdminData);
    return response;
  } catch (error) {
    return error;
  }
};

export const logout = () => {
  localStorage.remove();
  storePersist.clear();
};

export const fetchShopByOwner = async (params) => {
  try {
    const entity = apiConstants.GET_SHOP_INFO_BY_OWNER;
    const response = await request.get(`${entity}`, false, params);
    if (Object?.keys(response?.result)?.length > 0) {
      return {
        data: response?.result,
        success: true,
      };
    } else {
      return {
        data: response?.result,
        noShopData: true,
      };
    }
  } catch (error) {
    console.log("Error fetching shop info:", error);
  }
};

export const fetchNotificationsByUser = async (_id) => {
  try {
    const entity = apiConstants.NOTIFICATIONS;
    const response = await request.get(`${entity}/${_id}`, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching shop info:", error);
  }
};

export const logoutUser = async (_id) => {
  try {
    localStorage.remove();
    storePersist.clear();
    const entity = apiConstants.LOGOUT_USER;
    const response = await request.put(`${entity}/${_id}`, {}, false);
    return {
      data: response?.result,
      success: true,
    };
  } catch (error) {
    console.log("Error fetching shop info:", error);
  }
};
